import { render } from "./SharesView.vue?vue&type=template&id=25ecbfd0"
import script from "./SharesView.vue?vue&type=script&lang=js"
export * from "./SharesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__